<template>
  <side-bar title="Dodaj użytkownika" width='large' :visible="visible">
    <b-container fluid class="px-4 py-3">
      <b-row>
         <b-col>
           <!-- USER FORM FIELDS LOOP -->
           <div v-for="(f, index) in userFormFields" :key="index">
             <div v-if="f.items">
                <b-form-select
                  :options="f.items"
                  v-model="user[f.name]"
                  class="w-100 mt-4 h-12"
                />
               <field-error :errorsBag="formErrors" :fieldName="f.name" />
             </div>
             <div v-else>
               <vs-input
                :label="f.label"
                v-model="user[f.name]"
                class="w-100 mt-4"
              />
              <field-error :errorsBag="formErrors" :fieldName="f.name" />
             </div>
           </div>
        </b-col>
      </b-row>
      <b-row v-if="registerAgreementsState">
        <b-col class="mt-3" v-for="(a, index) in registerAgreements" :key="index">
            <vs-checkbox v-model="registerAgreementsState[a.uuid]" v-bind:class="{ required: a.is_required }">{{a.name}}</vs-checkbox>
            <field-error :errorsBag="formErrors" :fieldName="'agreements.'+a.uuid" />
        </b-col>
      </b-row>
      <b-row class="mt-8">
        <b-col cols="3">
           <vs-button type="filled round" icon="icon-plus" icon-pack="feather" @click="createUser">Dodaj</vs-button>
        </b-col>
        <b-col>
           <slot></slot>
        </b-col>
      </b-row>
    </b-container>
  </side-bar>
</template>

<script>
import FieldError from './../../../components/wod/forms/FieldError'
import {createUser} from './../../../mixins/users/usersMixin'
import {fetchRegisterAgreements} from './../../../mixins/agreements/agreementsMixin'
import SideBar from './../../../components/wod/SideBar'

export default {
  name: "createUserSideBar",
  mixins: [createUser, fetchRegisterAgreements],
  components: {
    SideBar,
    FieldError,
  },
  data() {
    return {
      formErrors: {},
    }
  },
  methods:{
    clearFormError(){
      this.formErrors = {}
    },

    createUser(){
      this.$vs.loading()
      const payload = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        gender: this.user.gender,
        province: this.user.province,
        employment_company: this.user.employment_company,
        employment_position: this.user.employment_position,
        email: this.user.email,
        type: this.user.type,
        agreements: this.registerAgreementsState,
      }
      this.$store.dispatch('userManagement/createUser', payload)
      .then( res =>{
        this.$vs.notify(notification.success('Użytkownik został dodany'))
      })
      .catch(error => {
        if(error.response){
          if(error.response.status === 422){
            this.formErrors =  error.response.data.errors
          } else {
            this.$vs.notify(notification.error(error.message))
          }
        }
      })
      .finally(()=>{
        this.$vs.loading.close()
      })
    },

  },

  props:{
    visible: Boolean,
  },
}
</script>

<style>

</style>
